export default __webpack_public_path__ + "static/media/1_0066.4e57b18a.webp";